module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAErSURBVGhD7ZQ/TgJBHIWXxpKCE1gpoeUUHsNWjYQD8KegtDextzbxEh6AG9jS0BsD73Uvkw27M8xMtnhf8hUU+75fCEtjjDHGGGOMMcJp4HbS9tCQ7KTtoSHZSdtDQ7I3X1AffIS1YEvbvCWaN6gjO1gLtrTNW6J5hjryCWvBlrZ5SzQPUEd+YC3Y0jZvieYe6sgB1oItbfOWaG7gP9ShMSwNG9rkDbwliV+oY3NYGja0yRuS+YY6toal2UBt8oZkllDHjjDp99iTKWRDmwuYzASGg3zBnuAtzAW3XmD48rLNG66C34CO1vQVZuEDtgVK+g6zMYJ8H8K/1RKywRabWbmDGvoLPl9juMVWdlZQI1uYC27pNlvZ2UONzGAuuKXbbBljjDHGmIs0zRn6PnUwWOZMBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bath/dark/48.png
// module id = 1871
// module chunks = 2